import * as JSONMapper from "json-mapper";
import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import * as localDate from "localDate";
import {Message} from "./common/message";
import {JeppProductItem} from "./jepp-product-item";

export class DeviceModel extends JSONMapped() {
	@jsonProperty()
	id: number;

	@jsonProperty()
	name: string;

	@jsonProperty()
	make: string;

	@jsonProperty()
	partKey: string;

	@jsonProperty()
	productID: number;

	@jsonProperty()
	minNumSystemId: number;

	@jsonProperty()
	maxNumSystemId: number;

	@jsonProperty()
	portable: boolean;

	@jsonProperty()
	oemVisible: boolean;

	@jsonProperty()
	minConciergeVersion: number;

	@jsonProperty()
	imageURL: string;

	@jsonProperty()
	supportCenterKey: string;

	@jsonProperty()
	hasBuiltInSDSlot: boolean;

	@jsonProperty()
	isConnectedCockpitCapable: boolean;

	@jsonProperty()
	isConnectedCockpitDevice: boolean;

	@jsonProperty()
	requiresOneTimeCode: boolean;

	@jsonProperty(JSONMapper.localDateFromISO)
	deletedAt: localDate.LocalDate;

	@jsonProperty()
	systemIdRequired: boolean;

	@jsonProperty()
	updateMethod: string;

	@jsonProperty()
	serialType: string;

	@jsonProperty()
	syncComments: string;

	@jsonProperty(JSONMapper.arrayOfClass(JeppProductItem))
	jeppesenProductCodes: Array<JeppProductItem>;

	@jsonProperty(JSONMapper.arrayOfClass(Message))
	messages: Array<Message>;

	@jsonProperty()
	isNandDevice: boolean;

	constructor(data?: Partial<DeviceModel>) {
		super();
		Object.assign(this, data);
	}

	get displayName(): string {
		if (this.make !== "Garmin")
			return `${this.make} ${this.name}`;
		return this.name;
	}

	get displaySerialType(): string {
		switch (this.serialType) {
			case DeviceModelSerialTypes.SYSTEM_ID:
				return "System ID";
			case DeviceModelSerialTypes.UNIT_ID:
				return "Unit ID";
			case DeviceModelSerialTypes.SERIAL:
				return "Serial Number";
			default:
				return "Device ID";
		}
	}

	get isDeleted(): boolean {
		return this.deletedAt !== null;
	}

	get additionalSoftwareURL() {
		if (this.supportCenterKey != null) {
			return `https://support.garmin.com/en-US/?productID=${this.supportCenterKey}&tab=software`;
		} else if (this.partKey != null) {
			return `https://support.garmin.com/en-US/?partNumber=${this.partKey}&tab=software`;
		} else {
			return null;
		}
	}

	get jeppChartEligible() {
		return this.jeppesenProductCodes != null && this.jeppesenProductCodes.length > 0;
	}
}

export enum DeviceModelSerialTypes {
	SYSTEM_ID = "SystemID",
	UNIT_ID = "UnitID",
	SERIAL = "Serial",
}
